import axios from 'axios';

// Получаем базовый URL из переменной окружения
// Для production будет относительный путь (пустая строка)
// Для development будет http://localhost:8080
const API_BASE_URL = process.env.REACT_APP_API_URL || '';

// Создаем экземпляр axios с предустановленными настройками
const api = axios.create({
  baseURL: API_BASE_URL,
});

// Добавляем перехватчик запросов для автоматического добавления JWT токена
api.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// Экспортируем функцию, которая создает полный URL
export const getApiUrl = (endpoint) => {
  // Убедимся, что endpoint начинается с /
  if (!endpoint.startsWith('/')) {
    endpoint = '/' + endpoint;
  }
  return `${API_BASE_URL}${endpoint}`;
};

export default api; 